
/**
 * Calcola il livello di rischio con un modello lineare
 * @param x variabile di ingresso
 * @param a valore associato al rischio minimo
 * @param b valore associato al rischio massimo
 * @return livello di rischio [0, 1]
 */
function linearRisk(x, a, b) {
    let r = (x - a) / (b - a)
    return Math.min(1, Math.max(0, r))
}


const CICLOCONIO_TEMPERATURE_A = 5
const CICLOCONIO_TEMPERATURE_B = 15
const CICLOCONIO_HUMIDITY_A = 60
const CICLOCONIO_HUMIDITY_B = 100
const CICLOCONIO_WETHOURS_A = 0
const CICLOCONIO_WETHOURS_B = 10

/**
 * Calcola il livello di rischio per l'avversità cicloconio
 * @param t temperatura atmosferica (°C)
 * @param u umidità atmosferica (%)
 * @param h numero ore di bagnatura (h)
 * @return livello di rischio [0, 1]
 */
export function evaluateRiskCicloconio(t, u, h) {
    let r = linearRisk(t, CICLOCONIO_TEMPERATURE_A, CICLOCONIO_TEMPERATURE_B) * linearRisk(u, CICLOCONIO_HUMIDITY_A, CICLOCONIO_HUMIDITY_B) * linearRisk(h, CICLOCONIO_WETHOURS_A, CICLOCONIO_WETHOURS_B)
    return Number((r * 10).toFixed(1))
}
